import { AspectRatio, Center, Container, Flex, Heading, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import NEURON_NETWORK_MAN_BLUE_IMAGE from '@/assets/images/presentation/man-and-neuron-network-blue.png';

import { Divider } from '@/components/ui/features/hybrid-events/CustomModel/components/Divider';
import { ModelDescription } from '@/components/ui/features/hybrid-events/CustomModel/components/ModelDescription';

export const CustomModel = () => {
  const { t } = useTranslation();

  return (
    <Center bgColor="black" position="relative">
      <AspectRatio
        objectFit="contain"
        w="full"
        maxW="2000px"
        bgColor="black"
        h={{ base: '710px', md: '512px', lg: '490px' }}
        ratio={16 / 9}
      >
        <Image
          src={NEURON_NETWORK_MAN_BLUE_IMAGE.src}
          alt="Neural network visualization"
          objectFit="cover"
          objectPosition="bottom"
        />
      </AspectRatio>
      <Container mx="auto" h="full" color="white" position="absolute">
        <Flex
          flexDirection="column"
          w="full"
          h="full"
          py={{ base: '48px', md: '100px', lg: '120px' }}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Heading fontSize={{ base: '3xl', md: '4xl' }}>{t('hybridEventsPage.customModels.heading')}</Heading>
          <Flex flexDirection={{ base: 'column', md: 'row' }} mt={{ base: 8, md: 14, lg: 18 }}>
            <ModelDescription
              title={t('hybridEventsPage.customModels.modelsList.0.title')}
              description={t('hybridEventsPage.customModels.modelsList.0.description')}
            />
            <Divider />
            <ModelDescription
              title={t('hybridEventsPage.customModels.modelsList.1.title')}
              description={t('hybridEventsPage.customModels.modelsList.1.description')}
            />
            <Divider />
            <ModelDescription
              title={t('hybridEventsPage.customModels.modelsList.2.title')}
              description={t('hybridEventsPage.customModels.modelsList.2.description')}
            />
            <Divider />
            <ModelDescription
              title={t('hybridEventsPage.customModels.modelsList.3.title')}
              description={t('hybridEventsPage.customModels.modelsList.3.description')}
            />
            <Divider />
            <ModelDescription
              title={t('hybridEventsPage.customModels.modelsList.4.title')}
              description={t('hybridEventsPage.customModels.modelsList.4.description')}
            />
          </Flex>
        </Flex>
      </Container>
    </Center>
  );
};
